import requests from '../requests'

export default {
  list () {
    return requests.get('compliance/terms')
  }
}
